import axios from "axios";
import { app_id, app_version, device_os, features } from "./Config";
const url = process.env.REACT_APP_API_BASE_URL;
const api_key = process.env.REACT_APP_API_KEY;
const getCommonHeaders = () => {
  let headers = {};
  headers["X_TIMESTAMP"] = Math.round(new Date() / 1000);
  headers["X_FEATURES"] = features;
  headers["X_APPID"] = app_id;
  headers["X_APPVERSION"] = app_version;
  headers["X_DEVICEOS"] = device_os;
  headers["X_APIKEY"] = api_key;

  return headers;
};

const submitFormApi = async ({ formID, payload }) => {
  try {
    let response = await axios({
      method: "post",
      url: `${url}external/webforms/${formID}/submit`,
      headers: {
        ...getCommonHeaders(),
      },
      data: payload,
    });
    return true;
  } catch (error) {
    return false;
  }
};

const openFormApi = async ({ formID }) => {
  try {
    let response = await axios({
      method: "post",
      url: `${url}external/webforms/${formID}/open`,
      headers: getCommonHeaders(),
    });
    return response.data;
  } catch (error) {
    return {};
  }
};

const getWebFormDataApi = async ({ formID }) => {
  try {
    let response = await axios({
      method: "get",
      url: `${url}external/webforms/${formID}`,
      headers: {
        X_APIKEY: api_key,
      },
    });
    return response.data;
  } catch (error) {
    return {};
  }
};

export { submitFormApi, openFormApi, getWebFormDataApi };
